import styles from './styles.module.scss'

type IVirtualSpacerRowProps = {
  colSpan: number
  height: number
}

export const VirtualSpacerRow = ({ colSpan, height }: IVirtualSpacerRowProps) => (
  <tr aria-hidden='true'>
    <td colSpan={colSpan} className={styles.virtualRowSpacer} style={{ height }} />
  </tr>
)

export const VirtualSkeletonRow = ({ colSpan, height }: IVirtualSpacerRowProps) => (
  <tr aria-hidden='true' style={{ height }}>
    <td colSpan={colSpan} className={styles.virtualRowSkeletonCell} />
  </tr>
)
